module.exports = __webpack_public_path__ + "static/media/horse-saddle.8b6bde3f.svg";